import React, { useEffect, useMemo, useState } from 'react';
import './UserStats.scss';
import { get } from '../../Utilities';
import { connect } from 'react-redux';
import { getLanguageObject } from '../../redux/reducers/clientUserId.reducer';
import { Modal } from 'react-bootstrap';

const multiColors = ['#e8f5e9', '#ffebee', '#f5f5f5', '#e3f2fd'];

const UserStats = (props) => {
  const { clientUserId, redirect=false, roleArray = [], clientId, languageObject = {}, showHeading=true, multiColor=false, history } = props;

  const [apiStats, setApiStats] = useState(null);
  const [dynamicStatsArray, setDynamicStatsArray] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState(null);

  useEffect(() => {
    if (!clientId || !roleArray[0]) return;

    get({ client_id: clientId, role_id: roleArray[0] }, '/getClientUserStatsArray').then((res) => {
      if (res?.success && Array.isArray(res.result)) {
        setDynamicStatsArray(res.result);
      }
    });
  }, [clientId, roleArray]);

  // Fetch the actual stat values
  useEffect(() => {
    if (!clientUserId) return;

    get(
      { client_user_id: clientUserId, client_id: clientId },
      clientId == 1104
        ? '/getUserDashboardStatsForKaryakarta'
        : '/getUserDashboardStats',
    ).then((res) => {
      if (res?.success) {
        setApiStats(res.result);
      }
    });
  }, [clientUserId, clientId]);

  // Map dynamic stats array structure with fetched values + translated labels
  const stats = useMemo(() => {
    if (!dynamicStatsArray.length) return [];

    const result = apiStats || {};

    return dynamicStatsArray.map((statConfig, index) => {
     
      const {
        id,
        key,
        label_key,
        label,
        unit = '',
        icon = '',
        bgColor = multiColor ? multiColors[index] : 'var(--lightest-blue)',
        info,
        special,
      } = statConfig;

      let value;
      if (key === 'courses_done') {
        value = sessionStorage.getItem('karyakarta_courses_completed') || 0;
      } else if (key) {
        value = result[key] ?? 0;
      } else {
        value = 0;
      }

      return {
        id,
        label: (key && languageObject[key]) || label || '',
        value,
        unit,
        icon,
        bgColor,
        info: info || null,
      };

    });
  }, [dynamicStatsArray, apiStats, languageObject]);

  const handleInfoClick = (info, label) => {
    setSelectedInfo(info);
    setSelectedLabel(label);
    setShowInfoModal(true);
  };

  const handleCloseModal = () => {
    setShowInfoModal(false);
    setSelectedInfo(null);
    setSelectedLabel(null);
  };

  return (
    <div className='UserStats__container mb-4'>
      {clientId !== 2002 && showHeading && (
        <h5 className='px-1 fontBoldBold mb-2'>{languageObject.statistics || 'Statistics'}</h5>
      )}

      <div className='UserStats__grid'>
        {stats.map((ele, index) => (
          <div role='button' onClick={() => {
            if(redirect) {
                history.push('/my-credit-profile');
            }
          }} key={ele.id} style={{ background: ele.bgColor }} className='UserStats__card'>
            <div className='UserStats__labelContainer'>
              <p className='UserStats__label'>{ele.label}</p>
              {ele.info && (
                <span className='UserStats__infoIcon' onClick={() => handleInfoClick(ele.info, ele.label)}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    fill='currentColor'
                    viewBox='0 0 16 16'
                  >
                    <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                    <path d='m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z' />
                  </svg>
                </span>
              )}
            </div>

            <div className='UserStats__valueContainer'>
              <h2 className='UserStats__value'>{ele.value}</h2>
              <span className='UserStats__unit'>{ele.value !== '-' && ele.unit}</span>
            </div>

            <div className='UserStats__icon'>
              <img
                className='UserStats__iconImage'
                style={index === 0 ? { width: '32px' } : {}}
                src={ele.icon}
                alt='stat-icon'
              />
            </div>
          </div>
        ))}
      </div>

      <Modal show={showInfoModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{fontFamily: 'Montserrat-SemiBold'}}>{selectedLabel || 'Info'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{fontFamily: 'Montserrat-Regular'}}>
          <div dangerouslySetInnerHTML={{__html: selectedInfo}} />
          </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  languageObject: getLanguageObject(state),

});

export default connect(mapStateToProps)(UserStats);
